import { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button, Menu, MenuItem } from 'components/common';
import { IHeaderMenuProps } from './types';

export const HeaderMenu: FC<IHeaderMenuProps> = ({ textId, menuOptions }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const isOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Button
        id='basic-button'
        aria-controls={isOpen ? 'menu-appbar' : undefined}
        aria-haspopup='true'
        aria-expanded={isOpen ? 'true' : undefined}
        onClick={handleClick}
        sx={{ color: 'white', lineHeight: '1.25rem' }}
      >
        <FormattedMessage id={textId} />
      </Button>
      <Menu
        id='menu-appbar'
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        MenuListProps={{ 'aria-labelledby': 'basic-button' }}
      >
        {menuOptions.map(({ link, textId }) => (
          <Link key={textId} to={link} className={'text-blue-500 no-underline'}>
            <MenuItem onClick={handleClose}>
              <FormattedMessage id={textId} />
            </MenuItem>
          </Link>
        ))}
      </Menu>
    </>
  );
};
